import axios from "axios";
import api from "./axiosInstance";
import useAuthStore from "../../shared/store/useAuthStore";

export const postRequest = async (url, payload, baseUrl) => {
  if (baseUrl) {
    const token = useAuthStore.getState().accessToken;
    const { data } = await axios.post(`${baseUrl}${url}`, payload, {
      timeout: 200000,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        ...(token && token !== "session_active" ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return data;
  }
  const { data } = await api.post(url, payload);
  return data;
};

export const putRequest = async (url, payload) => {
  const { data } = await api.put(url, payload);
  return data;
};

export const patchRequest = async (url, payload = {}) => {
  const response = await api.patch(url, payload);
  return { data: response.data, status: response.status };
};

export const deleteRequest = async (url, payload) => {
  const config = payload ? { data: payload } : {};
  const { data } = await api.delete(url, config);
  return data;
};
